export const productGetters = {
  // All products
  allProducts: (state, getters) => {
    return state.products
  },
  // Get Product by ID
  productById: (state, getters) => id => {
    if (getters.allProducts.length > 0) {
      return getters.allProducts.filter(p => p._id === id)[0]
    } else {
      return state.product
    }
  },
  allCategories:  (state, getters) => {
    return state.categories
  },
  usersProductById: (state, getters) => id => {
    return state.usersProductById (id)
  },
  allCalendars:  (state, getters) => {
    return state.calendars
  }
}

export const manufacturerGetters = {
  // All manufacturers
  allManufacturers: state => state.manufacturers
}



// WEBPACK FOOTER //
// ./src/store/getters.js